exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\r\n  font-weight: normal;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty-title/empty-title.component.css
// module id = ../../../../../src/app/shared/empty/empty-title/empty-title.component.css
// module chunks = 4